import SolisPhotoAlbum from "../../components/ImageAlbum/imageAlbum";

export const GalleryPage = () => {
  return (
      <SolisPhotoAlbum />
  );
};
